import { render, staticRenderFns } from "./AnnouncementMarquee.vue?vue&type=template&id=014d95fd&scoped=true&"
import script from "./AnnouncementMarquee.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementMarquee.vue?vue&type=script&lang=ts&"
import style0 from "./AnnouncementMarquee.vue?vue&type=style&index=0&id=014d95fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014d95fd",
  null
  
)

component.options.__file = "AnnouncementMarquee.vue"
export default component.exports